import $ from "jquery";
export const CART_UPDATED_EVENT = "cart-updated";

export function notify_cart_updated() {
  window.dispatchEvent(new CustomEvent(CART_UPDATED_EVENT));
}

export function encode_checkout_id(value) {
  return Number(value).toString(36);
}

export function decode_checkout_id(value) {
  const decoded_value = parseInt(String(value || ""), 36);

  return Number.isNaN(decoded_value) ? null : String(decoded_value);
}

function has_value(value) {
  return value !== undefined && value !== null && value !== "";
}

function build_order_slug({ order }) {
  return has_value(order) ? `order-${encode_checkout_id(order)}` : "";
}

function build_buy_now_slug({ cart, cart_item, buy_now }) {
  return has_value(cart) && has_value(cart_item) && buy_now
    ? `buy-now-${encode_checkout_id(cart)}-${encode_checkout_id(cart_item)}`
    : "";
}

function build_cart_item_slug({ cart, cart_item }) {
  return has_value(cart) && has_value(cart_item)
    ? `cart-item-${encode_checkout_id(cart)}-${encode_checkout_id(cart_item)}`
    : "";
}

function build_cart_slug({ cart }) {
  return has_value(cart) ? `cart-${encode_checkout_id(cart)}` : "";
}

const CHECKOUT_SLUG_BUILDERS = [
  build_order_slug,
  build_buy_now_slug,
  build_cart_item_slug,
  build_cart_slug,
];

function get_checkout_slug_key(parts = []) {
  return parts.slice(0, 2).join("-");
}

function parse_order_checkout_slug(parts = []) {
  return { order: decode_checkout_id(parts[1]) };
}

function parse_cart_item_checkout_slug(parts = []) {
  return {
    cart: decode_checkout_id(parts[2]),
    cart_item: decode_checkout_id(parts[3]),
  };
}

function parse_cart_checkout_slug(parts = []) {
  return { cart: decode_checkout_id(parts[1]) };
}

function parse_buy_now_checkout_slug(parts = []) {
  return {
    cart: decode_checkout_id(parts[2]),
    cart_item: decode_checkout_id(parts[3]),
    buy_now: true,
  };
}

const CHECKOUT_SLUG_PARSERS = {
  order: parse_order_checkout_slug,
  "cart-item": parse_cart_item_checkout_slug,
  cart: parse_cart_checkout_slug,
  "buy-now": parse_buy_now_checkout_slug,
};

export function create_checkout_slug({ cart, cart_item, order, buy_now } = {}) {
  const checkout_data = { cart, cart_item, order, buy_now };
  const slug = CHECKOUT_SLUG_BUILDERS
    .map((build_slug) => build_slug(checkout_data))
    .find(Boolean);

  return slug || "";
}

export function parse_checkout_slug(slug = "") {
  const parts = String(slug || "").split("-").filter(Boolean);
  const parser = CHECKOUT_SLUG_PARSERS[get_checkout_slug_key(parts)]
    || CHECKOUT_SLUG_PARSERS[parts[0]];

  return parser ? parser(parts) : {};
}

export function add_to_cart({ product_id, base_profile_id, token, quantity = 1, attributes = [] }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/add_to_cart/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        base_profile_id,
        product_id,
        quantity,
        attributes: Array.isArray(attributes) ? attributes : []
      }),
      success: (response) => {
        if (response?.status === "success") {
          notify_cart_updated();
        }
        resolve(response);
      },
      error: (error) => reject(error),
    });
  });
}

export function fetch_cart_for_profile({ base_profile_id, token }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_cart/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        base_profile_id,
      }),
      success: (response) => resolve(response),
      error: (error) => reject(error),
    });
  });
}

export function delete_cart_item({ cart_item_id, token }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_cart_item/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify({ cart_item_id }),
      success: (response) => {
        if (response?.status === "success") {
          notify_cart_updated();
        }
        resolve(response);
      },
      error: (error) => reject(error),
    });
  });
}

export function buy_now_order({ token, payload }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/buy_now/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
      success: (response) => resolve(response),
      error: (error) => reject(error),
    });
  });
}

export function get_sorted_attribute_ids(attributes = [], extractFn) {
    return (extractFn(attributes) || [])
        .map(id => String(id))
        .sort();
}

export function get_attribute_id(attribute) {
    if (!attribute || typeof attribute !== "object") return attribute;

    return  attribute.id;
}

export function extract_selected_attribute_ids(attributes = []) {
    if (!Array.isArray(attributes) || attributes.length === 0) return [];

    return [...new Set(
        attributes
            .filter(id => id !== null && id !== undefined && id !== '')
            .map(id => String(get_attribute_id(id)))
            .filter(id => id !== "undefined" && id !== "")
    )];
}

export function find_matching_cart_item(items = [],product_id, selected_attributes = [], extractFn) {
    const product_id_string = String(product_id);
    const selected_ids = get_sorted_attribute_ids(selected_attributes, extractFn);

    const matching_items = (items || []).filter((item) => {
        const item_product_id = item?.product?.id || item?.product_id;

        return String(item_product_id) === product_id_string;
    });

    return matching_items.find((item) => {
        const item_ids = get_sorted_attribute_ids(
            item?.product_attributes  || [],
            extractFn
        );

        return item_ids.length === selected_ids.length &&
            item_ids.every((id, index) => Object.is(id, Reflect.get(selected_ids, index)));
    }) || null;
}
